export default __webpack_public_path__ + "static/media/qr.4b517b5b.png";